import { Suspense } from 'react';
import { Routes, useLocation } from 'react-router-dom';
import PageLoader from './PageLoader';

/**
 * Remounts route tree on navigation so the previous page is not left visible
 * while the next lazy chunk loads (URL updates immediately in React Router).
 */
export default function RouteTransition({ children }) {
  const location = useLocation();

  return (
    <Suspense fallback={<PageLoader />} key={location.pathname}>
      <Routes location={location}>{children}</Routes>
    </Suspense>
  );
}
